import { COLOR_PALETTE } from 'constants/ui';

export const getSidebarStyles = variant => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  px: 1,
  backgroundColor: COLOR_PALETTE[variant][7],
  borderRadius: '10px',
});

export const getDotStyles = variant => ({
  width: 8,
  height: 8,
  backgroundColor: COLOR_PALETTE[variant][7],
  borderRadius: '50%',
});
